export default {
  pagination: {},
  events: [],
  tickets: [],
  sales: [],
  participants: [],
  totalAmount: 0,
  totalCount: 0,
  ticketsOverview: {},
  lots: [],
  lot: {}
};
